import { NeutralColors } from "../../constants/colors";
import styled from 'styled-components';
var Link = styled.a.withConfig({
  componentId: "sc-1x8d0af-0"
})(["color:", ";font:inherit;font-size:", ";position:relative;text-align:", ";text-decoration:underline;background:none;border:none;padding:0;cursor:pointer;outline:inherit;"], function (_ref) {
  var color = _ref.color;
  return color ? color : NeutralColors.Ink;
}, function (_ref2) {
  var fontSize = _ref2.fontSize;
  return fontSize ? fontSize : 'inherit';
}, function (_ref3) {
  var align = _ref3.align;
  return align ? align : 'initial';
});
export default Link;